import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://yxnhcffechgdovfakwfu.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl4bmhjZmZlY2hnZG92ZmFrd2Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzMjEyNzEsImV4cCI6MjA2Nzg5NzI3MX0.TiRT8no-8YRmlow_gcta3JR6oVcuVF-f2NRT0xuxX3Y'

export const supabase = createClient(supabaseUrl, supabaseKey, {
  db: { 
    schema: 'classroom' 
  },
  auth: {
    persistSession: true, // Disable session persistence for testing
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})